import React from "react";

const ManageSubscription = () => {
  return <div>ManageSubscription</div>;
};

export default ManageSubscription;
